/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/27/2023
 */
import React, { useState } from "react";
import PermissionsModal from "./PermissionsModal";
import DeleteModal from "./DeleteModal";
import EditRoleModal from "./EditRoleModal";
import ApproveCardItem from "./ApproveCardItem";
const ApprovedRoleItem = (props) => {
  const [permModalOpen, setPermModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalopen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  return (
    <div>
      <ApproveCardItem
        roleTitle={props.roleTitle}
        level={props.level}
        setEditModalOpen={setEditModalOpen}
        setDeleteModalopen={setDeleteModalopen}
        setPermModalOpen={setPermModalOpen}
      />
      <PermissionsModal
        open={permModalOpen}
        onClose={() => setPermModalOpen(false)}
        permissions={props.perms}
      />
      <DeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalopen(false)}
        title={props.roleTitle}
        setSuccessMessages={props.setSuccessMessages}
        setIsSuccess={props.setIsSuccess}
        setIsPendingChange={props.setIsPendingChange}
        setIserror={props.setIserror}
        setErrorMessages={props.setErrorMessages}
        setIserrorShow={props.setIserrorShow}
        setIsUnauhtError={props.setIsUnauhtError}
      />
      <EditRoleModal
        open={editModalOpen}
        existingRole={props.roleTitle}
        onClose={() => setEditModalOpen(false)}
        roleData={{
          role: props.roleTitle,
          level: props.level,
          desc: props.desc,
          permissions: props.perms,
        }}
        setIsPendingChange={props.setIsPendingChange}
      />
    </div>
  );
};
export default ApprovedRoleItem;
